// auth.js
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

let currentUser = null;

export default {
  // Method to check if the session cookie for user_id is not null or an empty string
  async isAuthenticated() {
    try {
      const res = await fetch(`${API_BASE}/get-logged-in-user`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) return false;
      const data = await res.json();
      currentUser = data?.user ?? null;
      return !!currentUser?.user_id;
    } catch {
      currentUser = null;
      return false;
    }
  },

  getUser() {
    return currentUser;
  }, 

  getUserID() {
    console.log("Called getUserID()");
    console.log("Current user id is: ", currentUser);
    return currentUser?.user_id ?? null;
  },
  getUserType() {
    return currentUser?.user_type ?? null;
    // return "student";
  },
  getUserName(){
    return currentUser?.first_name ?? null;
  },

  reset() {currentUser = null; },
};
